import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Divider,
  Switch,
  Space,
  Select,
} from 'antd';
import {
  DollarOutlined,
  FieldTimeOutlined,
  GoldOutlined,
} from '@ant-design/icons';
import { getCategories } from '../../services/kogan-category-service';
import _ from 'lodash';
import {
  FaWeightHanging,
  FaWeight,
  FaRulerVertical,
  FaRuler,
  FaRulerHorizontal,
} from 'react-icons/fa';

function ProductInfoTab({ form }) {
  const [categories, setCategories] = useState([]);

  const selectBefore = (
    <Select defaultValue="eBay" style={{ width: 100 }}>
      <Select.Option value="eBay">eBay</Select.Option>
      <Select.Option value="kogan">Kogan</Select.Option>
    </Select>
  );

  const debouncedCategorySearch = React.useRef(
    _.debounce(async (searchStr) => {
      if (searchStr) {
        const response = await getCategories(searchStr);
        const categories = response.data.results;
        setCategories(categories);
      } else {
        setCategories([]);
      }
    }, 1000)
  ).current;

  async function onCategorySearch(newValue) {
    debouncedCategorySearch(newValue);
  }
  useEffect(() => {
    return () => {
      debouncedCategorySearch.cancel();
    };
  }, [debouncedCategorySearch]);
  const onCategoryChange = (value, option) => {
    form.setFieldValue('category', option);
  };
  return (
    <>
      <Row gutter={[24, 0]} justify="start">
        <Col span={6}>
          <Form.Item label="Enabled" valuePropName="checked" name="enabled">
            <Switch />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="product_sku" label="SKU">
            <Input placeholder="Product SKU" disabled={true} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="product_gtin"
            label="GTIN"
            rules={[{ required: true, message: 'Please input GTIN/UPC/EAN' }]}
          >
            <Input placeholder="GTIN/UPC/EAN" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Location" name="product_location">
            <Input disabled={true} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]} justify={'start'}>
        <Col span={12}>
          <Form.Item
            name="product_title"
            label="Title"
            rules={[{ required: true, message: 'Please input product Title' }]}
          >
            <Input placeholder="Product Title" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="product_subtitle" label="Subtitle">
            <Input placeholder="Product Sub-title" />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name="category"
            label="Category"
            rules={[
              {
                required: true,
                message: 'Please input product Category',
              },
            ]}
          >
            {/* <InputNumber
                      placeholder="Product Category"
                      addonBefore={selectBefore}
                    /> */}
            <Select
              showSearch
              // value={value}
              // placeholder={props.placeholder}
              // style={props.style}
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              onSearch={onCategorySearch}
              onChange={onCategoryChange}
              notFoundContent={null}
              options={(categories || []).map((c) => ({
                value: c.CategoryID,
                label: c.CategoryPath,
              }))}
            />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item name="brand" label="Brand">
            <Input placeholder="Product Brand" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Condition" name="product_condition">
            <Input disabled={true} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Multipack" name="product_multipack">
            <InputNumber disabled={true} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[24, 0]} justify={'start'}>
        <Col span={12}>
          <Divider orientation="left">
            <Space>
              <DollarOutlined />
              <span>Stock & Price</span>
            </Space>
          </Divider>
          <Row gutter={[24, 0]} justify={'start'}>
            <Col span={8}>
              <Form.Item
                label="Price"
                name="price"
                rules={[
                  {
                    required: true,
                    message: 'Please input selling price',
                  },
                ]}
              >
                <InputNumber
                  placeholder="Price"
                  addonBefore={<DollarOutlined />}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="kogan_first_price" label="Kogan First Price">
                <InputNumber
                  placeholder="Kogan First Price"
                  addonBefore={<DollarOutlined />}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="rrp" label="Rec. Retail Price">
                <InputNumber
                  placeholder="RRP"
                  addonBefore={<DollarOutlined />}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="shipping" label="Shipping Cost">
                <InputNumber
                  placeholder="Shipping Price"
                  addonBefore={<DollarOutlined />}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="handling_days"
                label="Handling Days"
                rules={[
                  {
                    required: true,
                    message: 'Please input handling days',
                  },
                ]}
              >
                <InputNumber
                  placeholder="Handling Days"
                  addonBefore={<FieldTimeOutlined />}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="stock"
                label="Stock"
                rules={[
                  {
                    required: true,
                    message: 'Please input available stock quantity',
                  },
                ]}
              >
                <InputNumber
                  placeholder="Stock"
                  addonBefore={<GoldOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Divider orientation="left">
            <Space>
              <FaWeightHanging />
              <span>Wight & Dimensions</span>
            </Space>
          </Divider>
          <Row gutter={[24, 0]} justify={'start'}>
            <Col span={8}>
              <Form.Item label="Weight (kg)" name="weight">
                <InputNumber placeholder="Weight" addonBefore={<FaWeight />} />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item
                label="Calculate Shipping by Weight"
                valuePropName="checked"
                name="shipByWeight"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Length (cm)" name="length">
                <InputNumber
                  placeholder="Length"
                  addonBefore={<FaRulerHorizontal />}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Width (cm)" name="width">
                <InputNumber placeholder="Width" addonBefore={<FaRuler />} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Height (cm)" name="height">
                <InputNumber
                  placeholder="Height"
                  addonBefore={<FaRulerVertical />}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default ProductInfoTab;
